<template>
  <button @click.stop.prevent="goToSection()" class="btn-as-link" :class="{'is-selected': isSelected}">{{ sectionName }}</button>
</template>

<script>
export default {
  data: () => ({
    visiblePlaceHolderTopicIndex: 0
  }),
  props: {
    sectionSlug: {
      type: String,
      required: true
    },
    sectionName: {
      type: String,
      required: true
    },
    selectedSection: {
      type: String,
      required: true
    },
    query: {
      type: String,
      required: true
    }
  },
  mounted() {
  },
  computed: {
    isSelected () {
      return this.selectedSection == this.sectionSlug
    }
  },
  methods: {
    goToSection() {
      window.location = '/search?for=' + this.query + '&section=' + this.sectionSlug
    }
  }
}
</script>
